export enum ProjectType {
  SUPPLIER_PROJECT = 'supplierProject',
  DIGITALIZATION_PROJECT = 'digitalizationProject',
}
